import {analyticsLogger} from './analyticsLogger';

export type NavItemClickedProps = {
  /** Stable item id (not the translated label), e.g. `home`, `people`, `logo`. */
  item: string;
  path: string;
  location: 'left-nav' | 'navbar';
  /** True when the click lands on the page the person is already on. */
  isCurrent: boolean;
};

/** One event for every global nav click; `app_route` is the page it was clicked from. */
export const logNavItemClicked = ({item, path, location, isCurrent}: NavItemClickedProps) => {
  analyticsLogger().logEvent('NAV_ITEM_CLICKED', {
    item,
    path,
    location,
    is_current: isCurrent,
  });
};
